import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Query } from 'react-apollo';

import WithAuthService from '@/hocs/withAuthService';
import { SearchEventsV2 } from '@services/gql/content';
import eventResolver from '@/state/resolvers/event';

import trackCarouselEvents from '../../utils/trackCarouselEvents';

import EventList from './EventList.react';
import EventListCarousel from './EventListCarousel';
import LoadingEllipsis from '../LoadingEllipsis';
import EventSearchRecommendRace from '../EventSearchRecommendRace';

import { noResults } from './EventListContainer.module.css';

/**
 * Event list container element
 * Wraps the event list presentational component with Redux state
 * Dispatches actions fetching data, intitial and subsequent with load more button
 *
 * TODO: use custom event shape proptype
 * TODO: define query proptype shape, currently any parameters are accepted
 */

class EventListContainer extends Component {
  componentDidMount() {
    this.trackEvents();
  }

  sortedYearAgnosticDescending = (events) => {
    return events.sort(
      (event1, event2) =>
        event1.startMonthNumeric * 50 +
        event1.startDayNumeric -
        (event2.startMonthNumeric * 50 + event2.startDayNumeric),
    );
  };

  trackEvents = () => {
    const { events, title } = this.props;
    if (events && events.length) {
      trackCarouselEvents({ events, carouselTitle: title });
    }
  };

  render() {
    const {
      carousel,
      className,
      error,
      events,
      isReviewPage = false,
      lazy = false,
      loading,
      showPrompt,
      source,
    } = this.props;

    const hasUserCookie = this.props.authService.hasUserCookie();

    if (loading) {
      return (
        <div>
          <LoadingEllipsis />
        </div>
      );
    }

    if (!events.length) {
      if (error) {
        return (
          <div>
            <p>Sorry, there was an error loading the events.</p>
          </div>
        );
      }
      return carousel ? (
        <div>
          <p>Sorry, no events were found.</p>
        </div>
      ) : (
        <div>
          <div className={noResults}>
            <p>No results</p>
          </div>
          <EventSearchRecommendRace isSearchPage className="event-list__item" />
        </div>
      );
    }

    return (
      <div className={className}>
        {!carousel ? (
          <div>
            <EventList
              events={
                isReviewPage
                  ? this.sortedYearAgnosticDescending(events)
                  : events
              }
              hasUserCookie={hasUserCookie}
              isReviewPage={isReviewPage}
              showPrompt={showPrompt}
              source={source}
            />
          </div>
        ) : (
          <EventListCarousel
            events={
              isReviewPage ? this.sortedYearAgnosticDescending(events) : events
            }
            source={source}
            lazy={lazy}
          />
        )}
      </div>
    );
  }
}

EventListContainer.propTypes = {
  /**
   * Boolean describing whether list should be rendered with carousel.
   */
  carousel: PropTypes.bool,
  className: PropTypes.string,
  lazy: PropTypes.bool,
  /**
   * Boolean determining whether to show sign up prompt
   */
  showPrompt: PropTypes.bool,
  /**
   * Optional string source location of list.
   */
  source: PropTypes.string,
  /**
   * Optional string used in tracking
   */
  title: PropTypes.string,
};

EventListContainer.defaultProps = {
  carousel: false,
  className: '',
  lazy: false,
  showPrompt: false,
  source: undefined,
  title: '',
};

const EventListContainerWithGraphQL = (props) => {
  return (
    <Query
      query={SearchEventsV2}
      variables={{
        searchParametersInput: props.query,
      }}
    >
      {({ data, ...gqlData }) => {
        const gqlEvents = data?.searchEventsV2?.events || [];
        const events = gqlEvents.map(eventResolver);
        return <EventListContainer {...props} {...gqlData} events={events} />;
      }}
    </Query>
  );
};

export default WithAuthService(EventListContainerWithGraphQL);
